<template>
    <button type="button"
            :class="{
                'active': searchType == state.searchType
            }"
            @click="changeType">
        <img :src="badgeUrl" alt="">
        {{
            label
        }}
    </button>
</template>

<script>

export default {
    props   : ['label', 'searchType'],
    computed: {
        badgeUrl () {
            return this.state.imagePath.replace('__FILE__', 'storelocator_images/badge_' + this.searchType + '.png');
        },
    },
    methods: {
        changeType () {
            this.state.searchType = this.searchType;
        },
        
    }
};
</script>

<style scoped>
    button {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        appearance: none;
        width: 100%;
        background: none;
        border: none;
        padding: 10px 5px 20px;
        font-weight: 700;
        background: #eee;
        color: #000;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.24px;
    }

    button:hover {
        background: #f5f5f5;
    }

    button.active {
        background: #fff;
    }

    button img {
        display: block;
        margin: 10px auto 10px;
        width: 24px;
        height: 24px;
    }
</style>